import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import componentHelpers from './componentHelpers.js'
import bootstrapHelpers from './bootstrapHelpers.js'
import * as $ from 'jquery';

const bootstrapClasses = {
    fieldset: "clearfix mb-4 content-button-row",
    legend: "h3 mb-3 sid-question-legend",
    subText: bootstrapHelpers.paragraph(2, false) + " mb-5",
    group: "btn-group justify-content-center",
    input: "btn-check",
    label: "btn btn-light text-uppercase fw-bold fs-medium ms-1 btn-padding-small btn-hover",
    explanation: "d-flex mb-3",
    lowText: "me-auto pt-2 text-uppercase text-left fs-small",
    highText: "pt-2 text-uppercase text-right fs-small",
    selected: null
};

const legacyClasses = {
    fieldset: "sid-clearfix",
    legend: "sid-question-text",
    subText: "",
    group: "btn-group d-flex w-100",
    input: "visually-hidden",
    label: "sid-row-button w-100",
    explanation: "",
    lowText: "button-row-under-left",
    highText: "button-row-under-right",
    selected: "sid-button-selected"
};

export class ButtonRow extends DesigntimeComponent {
    static staticName = "ButtonRow";
    static staticId = "buttonRow";
    runtimeValue = 1;
    context;

    constructor(identifyer) {
        super(identifyer, 1);

        this.disableNextButton();

        this.values = {
            text: new LiquidString("text", `${this.id}_text`),
            subText: new LiquidString("Indicate the extent this statement applies to you and your gambling over the last 3 months.", `${this.id}_subText`),
            lowText: { value: "Completely disagree" },
            highText: { value: "Completely agree" },
            numberOfButtons: { value: 10, dontTranslate: true },
            startButton: { value: 0, dontTranslate: true },
            buttontext: { value: "Next" },
            nextOnClick: { value: "false", dontTranslate: true, description: "Set to 'true' if next component should be shown without next-button click" }
        };
    }

    getRuntimeView(context) {
        this.context = context;
        return this.#buildView(context.params.useBootstrapUi ? bootstrapClasses : legacyClasses);
    }

    #buildView(classes) {
        const first = +this.values.startButton.value;
        const last = +this.values.numberOfButtons.value;
        const lowTextId = `${this.id}_lowText`;
        const highTextId = `${this.id}_highText`;

        let $view = $("<div></div>");

        // "Statement n of total" above the question, focused when the question is shown, see onNodeShown.
        // Only for screen readers unless the brand shows it (params.showQuestionCounter).
        const counterClass = this.context.params.showQuestionCounter ? "sid-item-counter" : "visually-hidden";
        $view.append(`<h2 id="${this.id}_counter" class="${counterClass}" tabindex="-1"></h2>`);

        let $fieldset = $(`<fieldset class="${classes.fieldset}"></fieldset>`);
        $fieldset.append(this.values.text.getTag("legend", classes.legend));
        $fieldset.append(this.values.subText.getTag("p", classes.subText));

        let $group = $(`<div class="${classes.group}" role="radiogroup"></div>`)
            .attr("aria-labelledby", this.values.text.getUniqueId())
            .attr("aria-describedby", `${this.values.subText.getUniqueId()} ${lowTextId} ${highTextId}`);

        for (let i = first; i <= last; i++) {
            const inputId = `${this.id}_answer_${i}`;

            let $input = $(`<input type="radio" class="${classes.input}" autocomplete="off">`)
                .attr({ id: inputId, name: `${this.id}_answer`, value: i, "aria-label": `${i} / ${last}` });

            if (i == first)
                $input.attr("aria-describedby", lowTextId);
            if (i == last)
                $input.attr("aria-describedby", highTextId);
            if (this.values.nextOnClick.value == "true")
                $input.addClass("internal-next-button");

            let $label = $(`<label class="${classes.label}" for="${inputId}">${i}</label>`);

            $input.on("change", function () {
                if (classes.selected) {
                    $group.find("label").removeClass(classes.selected);
                    $label.addClass(classes.selected);
                }
                this.runtimeValue = i;
                this.enableNextButton();
            }.bind(this));

            $group.append($input, $label);
        }
        $fieldset.append($group);

        let $explanation = $(`<div class="${classes.explanation}"></div>`);
        $explanation.append($(`<p class="${classes.lowText}"></p>`).attr("id", lowTextId).html(this.values.lowText.value));
        $explanation.append($(`<p class="${classes.highText}"></p>`).attr("id", highTextId).html(this.values.highText.value));
        $fieldset.append($explanation);

        $view.append($fieldset);

        return $view;
    }

    onNodeShown() {
        const $questions = $("#component-container .sid-component_type_buttonRow");
        const position = $questions.index(componentHelpers.getRtFrame(this.id)) + 1;

        const $counter = $(`#${this.id}_counter`);
        $counter.text(componentHelpers.uiText(this.context, "si_pts_dialog_question_counter", "Statement {{n}} of {{total}}", { n: position, total: $questions.length }));

        // Brands with the next button inside the question's card (params.nextButtonInQuestion)
        if (this.context.params.nextButtonInQuestion)
            this.eventBroker?.fire("placeNextButtonEvent", componentHelpers.getRtFrame(this.id));

        // Wait for the fade-in, otherwise the element can't take focus yet. Without scrolling, so the
        // page (or the parent page, when embedded in an iframe) doesn't jump on every question.
        setTimeout(() => {
            $counter[0]?.focus({ preventScroll: true });

            // With the next button at the bottom of the card, the user has often scrolled down to it,
            // so bring the new question's top back into view when it's above the screen
            const frame = componentHelpers.getRtFrame(this.id)[0];
            if (this.context.params.nextButtonInQuestion && frame && frame.getBoundingClientRect().top < 0)
                frame.scrollIntoView({ block: "start" });
        }, +this.context.params.fadeInDelay);
    }

    getOutput() {
        return {
            value: this.runtimeValue,
        };
    }

    importModel(model) {

        super.importModel(model);

        if (!this.values.startButton) {
            this.values.startButton = { value: 0, dontTranslate: true };
        }
    }

    output = [
        { name: "value", type: "int" }
    ];
}
